// removed by extract-text-webpack-plugin
module.exports = {"rightcol":"src-components-modules-Integrations-style----rightcol-module---rightcol---2FwiM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Integrations/style/rightcol.module.css
// module id = 1482
// module chunks = 87034247430840